const isRumouredEntity = (entity) => entity && entity.rumoured;

export default isRumouredEntity;
